import { useId } from "react";

/**
 * OptionGroup - a labelled group (role="group") for related controls such as
 * ChoiceCards, toggle buttons or checkbox lists.
 *
 * @param {object} props
 * @param {React.ReactNode} props.label Visible group label.
 * @param {React.ReactNode} [props.hint] Helper text under the label.
 * @param {string} [props.className]
 */
const OptionGroup = ({ label, hint, className, children }) => {
  const labelId = useId();
  const hintId = hint ? `${labelId}-hint` : undefined;
  return (
    <div role="group" aria-labelledby={labelId} aria-describedby={hintId} className={className}>
      <p id={labelId} className="mb-1.5 block text-sm font-medium text-fg">
        {label}
      </p>
      {hint && (
        <p id={hintId} className="-mt-0.5 mb-3 text-xs text-fg-muted">
          {hint}
        </p>
      )}
      {children}
    </div>
  );
};

export default OptionGroup;
